import { render, staticRenderFns } from "./allPayStat.vue?vue&type=template&id=d5c202ba&scoped=true&"
import script from "./allPayStat.vue?vue&type=script&lang=js&"
export * from "./allPayStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5c202ba",
  null
  
)

export default component.exports